export interface Banner {
  id?: number;
  merchantId?: number;
  internalName: string;
  title: string;
  subtitle?: string;
  type: BannerType;
  sortNumber: number;
  link: string;
  target: string;
  image: string;
  mobileImage: string;
  startDate: string;
  endDate: string;
  displayTimeSeconds?: number;
  videoSrc?: string;
  textboxPlacement?: PlacementType;
  textboxButton?: string;
  height?: string;
  maxHeight?: string;
  mobileHeight?: string;
  mobileMaxHeight?: string;
  brightness: number;
  productOnly: boolean;
  productIds?: number[];
  kioskOnly: boolean;
}

export enum BannerType {
  Left,
  Right,
  Full,
  Hero,
  Streamer,
}

export enum PlacementType {
  TopLeft,
  TopMiddel,
  TopRight,
  BottomLeft,
  BottomMiddel,
  BottomRight,
}

export const textboxPlacementClass = ['top left', 'top middel', 'top right', 'bottom left', 'bottom middel', 'bottom right'];
